/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Categories_RuntimeInputs */

const en_us2_technologies_categories_runtime = /** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runtime`)
};

const es_es2_technologies_categories_runtime = /** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entorno de ejecución`)
};

const ru_technologies_categories_runtime = /** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рантайм`)
};

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const id_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const ms_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const da_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const de_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const es_mx2_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const fil_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const fr_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const it_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const hu_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const nl_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const no_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const pl_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const pt_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const pt_br2_technologies_categories_runtime = pt_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const ro_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const fi_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const sv_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const vi_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const tr_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const cs_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const bg_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const uk_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const ar_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const hi_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const th_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const ja_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const zh_cn2_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const zh_hant1_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/** @type {(inputs: Technologies_Categories_RuntimeInputs) => LocalizedString} */
const ko_technologies_categories_runtime = en_us2_technologies_categories_runtime;

/**
* | output |
* | --- |
* | "Runtime" |
*
* @param {Technologies_Categories_RuntimeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_categories_runtime = /** @type {((inputs?: Technologies_Categories_RuntimeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Categories_RuntimeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_categories_runtime(inputs)
	if (locale === "ms") return ms_technologies_categories_runtime(inputs)
	if (locale === "da") return da_technologies_categories_runtime(inputs)
	if (locale === "de") return de_technologies_categories_runtime(inputs)
	if (locale === "en-US") return en_us2_technologies_categories_runtime(inputs)
	if (locale === "es-ES") return es_es2_technologies_categories_runtime(inputs)
	if (locale === "es-MX") return es_mx2_technologies_categories_runtime(inputs)
	if (locale === "fil") return fil_technologies_categories_runtime(inputs)
	if (locale === "fr") return fr_technologies_categories_runtime(inputs)
	if (locale === "it") return it_technologies_categories_runtime(inputs)
	if (locale === "hu") return hu_technologies_categories_runtime(inputs)
	if (locale === "nl") return nl_technologies_categories_runtime(inputs)
	if (locale === "no") return no_technologies_categories_runtime(inputs)
	if (locale === "pl") return pl_technologies_categories_runtime(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_categories_runtime(inputs)
	if (locale === "pt") return pt_technologies_categories_runtime(inputs)
	if (locale === "ro") return ro_technologies_categories_runtime(inputs)
	if (locale === "fi") return fi_technologies_categories_runtime(inputs)
	if (locale === "sv") return sv_technologies_categories_runtime(inputs)
	if (locale === "vi") return vi_technologies_categories_runtime(inputs)
	if (locale === "tr") return tr_technologies_categories_runtime(inputs)
	if (locale === "cs") return cs_technologies_categories_runtime(inputs)
	if (locale === "bg") return bg_technologies_categories_runtime(inputs)
	if (locale === "ru") return ru_technologies_categories_runtime(inputs)
	if (locale === "uk") return uk_technologies_categories_runtime(inputs)
	if (locale === "ar") return ar_technologies_categories_runtime(inputs)
	if (locale === "hi") return hi_technologies_categories_runtime(inputs)
	if (locale === "th") return th_technologies_categories_runtime(inputs)
	if (locale === "ja") return ja_technologies_categories_runtime(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_categories_runtime(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_categories_runtime(inputs)
	return ko_technologies_categories_runtime(inputs)
});
export { technologies_categories_runtime as "technologies.categories.runtime" }